export default __webpack_public_path__ + "static/card-debit@3x-abb038bc355937579a7e69abb3c7db22.png";